import orderItem from "@/components/orderItem.vue";
import floatingStrip from "@/components/floatingStrip.vue";
import { getOrderList, indexFeaturedGet, cancelOrder } from "@/libs/api";
import { getCookie } from "@/libs/common.js";
export default {
	name: "orderConfirm",
	components: { orderItem ,floatingStrip},
	data() {
		return {
			isShowCanncel: false,
			canncelIndex: "",
			canncelList: [],
			currentCanncel: 1,
			currentCanncelId: "",
			currentOrderTag:'',
			currentBusinessType:'',
			active: 0,
			listStatus: 0, // 0-初始化 1-有数据 2-无数据
			navList: [
				{
					name: "全部",
				},
				{
					name: "待付款",
				},
				{
					name: "待收货",
				},
				{
					name: "已签收",
				},
				// {
				// 	name: "待评价",
				// },
				{
					name: "已取消",
				},
			],
			query: {
				pageSize: 10,
				startIndex: 1,
				orderStatus: "",
				merchantBackurl: "2",
			},
			param: [],
			list: [],
			loading: false,
			finished: false,
			finishedText: "",
			isLoad: false,
			freshActType: '',
			isShowFloatStrip:false,
		};
	},
	mounted() {
		this.active = Number(this.$route.query.active) || 0; // 获取当前导航选中
		this.query.orderStatus = this.getOrderStatus(); // 获取当前订单状态
		this.freshActType = this.$route.query.freshActType || getCookie("ispioltCity");
		if (this.freshActType != 1) {
			this.isShowFloatStrip = true;
		}
		this.fetch();
	},
	activated() {
		this.active = Number(this.$route.query.active) || 0; // 获取当前导航选中
		this.query.orderStatus = this.getOrderStatus();
	},
	watch: {
		$route(to, from) {
			// console.log(from.name);
			// console.log(to.name);
			if ((from.name === "orderList" || from.name === "userCenter") && to.name === "orderList") {
				this.query.orderStatus = this.getOrderStatus();
				this.list = [];
				this.listStatus = 0;
				this.query.startIndex = 1;
				this.finishedText = "";
				this.fetch();
			}
		},
	},
	methods: {
		// 获取列表
		fetch() {
			this.$toast.loading({
				duration: 0,
				mask: true,
				message: "加载中...",
			});
			getOrderList(this.query, "jsonCallback").then((res) => {
				this.loading = false;
				this.finished = false;
				console.log(res)
				if (res.returnCode === "0000") {
					this.$toast.clear();
					if (!res.data) {
						this.finished = true;
						this.finishedText = "";
						this.listStatus = 2;
					} else {
						this.param = [];
						let totalPages = Math.ceil(res.total / this.query.pageSize);
						this.listStatus = 1;
						this.list = this.list.concat(res.data);
						this.list.forEach((item, index) => {
							this.param.push({
								merchantId: item.sellerOnlyid,
								storeId: item.storeId,
								source: "order",
							});
							// 试点城市订单显示团长信息
							if (item.orderTag.indexOf('100027') >=0 ) {
								item.isPolitCity = true;
							}
							if (item.delevery.length > 0) {
								item.delevery[0].prd.forEach((ele) => {
									ele.attributes = ele.attributes.replace("|.|", "&nbsp;&nbsp;&nbsp;&nbsp;");
								});
							}
						});
	
						let obj = JSON.stringify(this.param);
						this.$axios.post(`//livechat.${this.$uleUrl()}/uleImService/imService/multiCustServOnlineStatu`, { param: obj }).then((res) => {
							if (res.data.returnCode === "0000") {
								res.data.data.forEach((item, index) => {
									if (item === "online") {
										if (this.list[index].kefuStatus === undefined) {
											this.$set(this.list[index], "kefuStatus", true);
										} else {
											this.list[index].kefuStatus = true;
										}
									} else {
										if (this.list[index].kefuStatus === undefined) {
											this.$set(this.list[index], "kefuStatus", false);
										} else {
											this.list[index].kefuStatus = false;
										}
									}
								});
							}
						});
						if (this.query.startIndex == totalPages) {
							this.finished = true;
							this.finishedText = "我已到达底部, 暂无其他数据啦~~";
						} else {
							this.finished = false;
							this.query.startIndex++;
						}
					}
				} else {
					this.finished = true;
				}
			});
		},
		// 初始列表
		initList(){
			this.list = [];
			this.query.startIndex = 1;
			this.fetch();
		},
		// 导航切换
		tapNav(index) {
			this.$router.push({
				path: `/order/orderList`,
				query: {
					active: index,
				},
			});
		},
		// 删除
		deleteIndex(index) {
			this.list.splice(index, 1);
			if (this.list.length === 0) {
				this.listStatus = 2;
			}
		},
		// 获取订单状态
		getOrderStatus() {
			let active = Number(this.$route.query.active) || 0;
			this.active = active;
			switch (active) {
				case 0:
					return "";
				case 1:
					return "3";
				case 2:
					return "5";
				case 3:
					return "7";
				// case 4:
				// 	return "72";
				case 4:
					return "1";
			}
		},
		// 获取取消弹层点击的第几个
		getIndex(res) {
			this.canncelIndex = res;
		},
		// 获取取消弹层是否显示
		getCanncelPop(res) {
			this.isShowCanncel = res;
			this.canncelList = [];
			indexFeaturedGet("jsonpCallback").then((res) => {
				if (res.returnCode === "0000") {
					res.indexInfo.forEach((item, index) => {
						this.canncelList.push({
							name: item.attribute1,
							id: item.id,
							radio: index + 1,
						});
					});
				}
			});
		},
		// 获取子组件的订单号
		getOrderId(orderId) {
			this.currentCanncelId = orderId;
		},
		// 获取子组件OrderTag
		getOrderTag(orderTag) {
			this.currentOrderTag = orderTag
		},
		// getBusinessType
		getBusinessType(businessType) {
			this.currentBusinessType = businessType
		},
		// 选择取消理由
		selectCanncel(radio) {
			this.currentCanncel = radio;
		},
		// 关闭理由框弹层
		closeCanncelPop() {
			this.isShowCanncel = false;
			this.currentCanncel = 1;
		},
		// 确认取消
		canncelHandel() {
			this.$toast.loading({
				duration: 0,
				mask: true,
				message: "处理中...",
			});
			let cancelReason = "";
			this.canncelList.forEach((item) => {
				if (item.radio === this.currentCanncel) {
					cancelReason = item.name;
				}
			});
			let data = {
				orderId: this.currentCanncelId,
				cancelReason,
				clientCallType: "H5",
			};
			cancelOrder(data, "jsonCallback")
				.then((res) => {
					if (res.code === "0000") {
						setTimeout(() => {
							this.$toast("操作成功");
							// 如果订单是待付款状态 直接删除
							if (this.active === 1) {
								this.list.splice(this.canncelIndex, 1);
							}
							if (this.list.length === 0) {
								this.listStatus = 2;
							}
						}, 500);
					} else {
						this.$toast(res.msg);
					}
				})
				.catch((error) => {
					this.$toast("操作失败！");
				});
			this.isShowCanncel = false;
		},
		//跳转订单详情
		toOrderDetail(item){
			this.toNext(`/order/orderInfo/${item.escOrderId}`, { refresh: false });
		},
		orderBack(){
			if (this.$browser().miniprogram) {
				window.wx.miniProgram.switchTab({
					url: "/pages/userCenter/index"
				  });
			}else{
				this.toNext('/me/userCenter')
			}
		}
	},
};
